import { hash } from 'fast-sha256';

const bytesToHex = (u8: Uint8Array) => Array.from(u8, (b) => b.toString(16).padStart(2, '0')).join('');

const strToBytes = (str: string): Uint8Array => {
  // Browser / modern node
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(str);
  }
  // fallback
  return new Uint8Array(Buffer.from(str, 'utf8'));
};

/**
 * SHA-256 using fast-sha256
 * @param input - string to hash
 * @returns 64-char lowercase hex string
 */

export function hashSha256(input: string): string {
  const data = strToBytes(input);
  return bytesToHex(hash(data));
}

/**
 * Trim leading/trailing whitespace
 * Lowercase all characters
 */
function normaliseEmail(input: string): string {
  return input.trim().toLowerCase();
}

export function normalisePhoneForMeta(input: string): string {
  const withoutNonDigits = input.replace(/\D+/g, '');
  const noLeadingZeros = withoutNonDigits.replace(/^0+/, '');
  return noLeadingZeros;
}

/**
 * Google Analytics phone formatting
 * Remove spaces, dashes, and parentheses, no non digits unless e.164
 */
export function normalisePhoneForGoogle(input: string): string {
  const trimmed = input.trim();

  // Remove spaces, dashes, and parentheses
  const formatString = trimmed.replace(/[\s\-()]/g, '');

  // If the original string started with '+', preserve it and strip all non-digits after it
  if (formatString.startsWith('+')) {
    const digits = formatString.slice(1).replace(/\D+/g, '');
    return `+${digits}`;
  }

  // Otherwise, strip all non-digits
  return formatString.replace(/\D+/g, '');
}

/**
 * generic hash without normalisation
 */
export function hashedItem(item: string): string {
  return hashSha256(item);
}

/**
 * Normalise and hash email
 */
export function hashedEmail(email: string): string {
  return hashSha256(normaliseEmail(email));
}

/**
 * Normalise and Hash a phone for Meta
 */
export function hashedMetaPhone(phone: string): string {
  return hashSha256(normalisePhoneForMeta(phone));
}

/**
 * Normalise and Hash a phone for Google Ads
 * Note: We are not enforcing E.164
 */
export function hashedGooglePhone(phone: string): string {
  return hashSha256(normalisePhoneForGoogle(phone));
}
